import { HeaderSearch, Item, ProductCompactSkeleton } from 'ui/components';
const HeaderSkeletonSearch = ({ focus }: { focus: boolean }) => (
  <HeaderSearch.List counter={false} data-visible={focus} rounded>
    <Item>
      <ProductCompactSkeleton />
    </Item>
    <Item>
      <ProductCompactSkeleton />
    </Item>
    <Item>
      <ProductCompactSkeleton />
    </Item>
  </HeaderSearch.List>
);

export default HeaderSkeletonSearch;
